import axios from "axios";
import { loginError } from "../store/actions";
import {
  getLedgerbookError,
  getLedgerbookSuccess,
  getLedgerbooks,
} from "../store/actions";

export class LedgersBooksService {
  static LedgersList = (req) => {
    return (dispatch) => {
      dispatch(getLedgerbooks());
      axios
        .post(`${process.env.REACT_APP_API_URL + "/" + req.type}`, req.filter, {
          headers: {
            "content-Type": "application/json",
            session: `${req.token}`,
            Authkey: `${process.env.REACT_APP_API_AUTH_KEY}`,
          },
        })
        .then((response) => {
          if (response.data.status === 1) {
            dispatch(getLedgerbookSuccess(response.data));
          } else if (response.data.message === "Record not found") {
            dispatch(getLedgerbookSuccess(response.data));
          } else {
            dispatch(getLedgerbookError(response.data.message));
          }
        })
        .catch((error) => {
          if (error.response.data === "Unauthorized.") {
            dispatch(loginError("Session Expired !"));
            global.localStorage.clear();
          } else {
            console.log("Login error");
            dispatch(getLedgerbookError("No Data Found !"));
          }
        });
    };
  };
}
